import { flatten } from 'lodash';
import { BindingGroupDto } from '../types';
import { InputBinding } from '../../iota_applications/types';

export interface BindingGroupBaseline {
    bindingGroupId: string;
    name: string;
    enabled: boolean;
    childBindingGroups: ReadonlyArray<BindingGroupBaseline>;
}

export interface BindingGroupContent extends BindingGroupBaseline {
    inputs: ReadonlyArray<{ bindings: InputBinding[] }>;
    childBindingGroups: ReadonlyArray<BindingGroupContent>;
}

export const hasBindingValue = (binding: InputBinding): boolean =>
    binding.value !== null && binding.value !== undefined && binding.value !== '';

export const serializeBindingGroupContent = (
    groups: ReadonlyArray<BindingGroupContent>,
    defaults: ReadonlyArray<BindingGroupBaseline>,
    exportBinding: (binding: InputBinding) => InputBinding = binding => ({ ...binding })
): BindingGroupDto[] => {
    const content: BindingGroupDto[] = [];
    const defaultsById = new Map(defaults.map(group => [group.bindingGroupId, group]));
    for (const group of groups) {
        const baseline = defaultsById.get(group.bindingGroupId);
        const bindings = flatten(group.inputs.map(input => input.bindings))
            .filter(hasBindingValue)
            .map(exportBinding);
        const children = serializeBindingGroupContent(
            group.childBindingGroups,
            baseline?.childBindingGroups ?? [],
            exportBinding
        );
        if (
            bindings.length ||
            children.length ||
            group.name !== baseline?.name ||
            group.enabled !== baseline?.enabled
        ) {
            content.push({
                bindingGroupId: group.bindingGroupId,
                name: group.name,
                enabled: group.enabled,
                bindings,
                childBindingGroups: children
            });
        }
    }
    return content;
};
